module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG9ee27825cd397536c990e8af40b6679d.9ee27825.png";